"use client";

// import { STAKING_APP_URL } from "@/config";
import SecondaryButton from "../../SecondaryButton/SecondaryButton";

export default function ClaimedScreen({
  onNext,
  allocatedSpon,
}: {
  onNext: () => void;
  allocatedSpon: number;
}) {
  return (
    <>
      <div className="flex flex-col gap-y-6">
        <p className="font-albert-sans text-2xl leading-7 text-white uppercase text-center">
          Claimed Successfully
        </p>
      </div>
      <div className="flex flex-col gap-4 text-[#9D9D9D]">
        <p>
          You've successfully claimed{" "}
          <span className="text-white font-semibold">
            {Number(allocatedSpon.toFixed(6))} SPON
          </span>
          , congrats! That's more than a balance! it's fuel to deploy workloads,
          lease GPUs or CPUs, or even run a node and earn on the Spheron
          Network.
        </p>
        <p>
          Keep diving into the ecosystem - our Console, Supernoderz, KlippyAI,
          Fizz or Provider nodes, and community channels - to uncover tools,
          rewards, and collaborations built for innovators like you.{" "}
        </p>
        <p>
          Thank you for backing open, community-powered compute. We can't wait
          to see what you build next!
        </p>
        {/* <p>
          We highly recommend that you stake it to get staking and bonus rewards
          for securing the network.
        </p> */}
        {/* <SecondaryButton
          onClick={() => {
            window.open(STAKING_APP_URL, "_blank");
          }}
          variant="light"
        >
          Stake now
        </SecondaryButton> */}
        <SecondaryButton
          onClick={() => {
            onNext();
          }}
          variant="light"
        >
          CLOSE
        </SecondaryButton>
      </div>
    </>
  );
}
